import { Page } from '@/pages/AdvancedEditor/AdvancedEditor';
import { useAddAvatarToPolotno } from '@/pages/AdvancedEditor/components/panels/avatars/utils/useAddAvatarToPolotno';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import { PolotnoStoreActivePageKeys, setPageProperty } from '@/pages/AdvancedEditor/hooks';
import { useNormalizePolotnoInitialData } from './useNormalizePolotnoInitialData';

export const useInitWithWalksThrough = () => {
    const { store } = useAdvancedEditorContext();
    const addAvatar = useAddAvatarToPolotno();
    const { normalizeWalkthroughData } = useNormalizePolotnoInitialData();

    const initWithWalksThrough = async (page: Page) => {
        const normalizedWalkthroughData = normalizeWalkthroughData();

        setPageProperty(page, PolotnoStoreActivePageKeys.textInput)(normalizedWalkthroughData.text);

        if (normalizedWalkthroughData.avatar) {
            addAvatar(store.activePage, normalizedWalkthroughData.avatar);
        }
    };

    return { initWithWalksThrough };
};
